import { createClient } from "@supabase/supabase-js";
import { getBrowserSupabaseConfig } from "./browserConfig";

const { url, publishableKey } = getBrowserSupabaseConfig();

export const isSupabaseConfigured = Boolean(url && publishableKey);

export const supabase = isSupabaseConfigured
  ? createClient(url, publishableKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true }
    })
  : null;
